/** @public */
function getVariantContent(setiControl, collection) {
    switch (setiControl) {
        case collection.variant1Name:
            return collection.variant1Content;
        case collection.variant2Name:
            return collection.variant2Content;
        case collection.variant3Name:
            return collection.variant3Content;
        case collection.variant4Name:
            return collection.variant4Content;
        case collection.variant5Name:
            return collection.variant5Content;
        default:
            return collection.defaultContent;
    }
}
export default getVariantContent;
//# sourceMappingURL=getVariantContent.js.map